import { Placeholder } from '@/components';

import styles from './SummaryTotalSkeleton.module.scss';
import { FC } from 'react';
import classNames from 'classnames';

interface ISummaryTotalSkeleton {
  elements?: number;
  classname?: string;
}

const SummaryTotalSkeleton: FC<ISummaryTotalSkeleton> = ({
  elements = 3,
  classname,
}) => {
  return (
    <div className={classNames(styles.summary_skeleton__container, classname)}>
      {Array.from({ length: elements }).map((_, i) => (
        <div className={styles.summary_skeleton} key={i}>
          <Placeholder className={styles.summary_skeleton__item_large} />
          <Placeholder className={styles.summary_skeleton__item} />
        </div>
      ))}
    </div>
  );
};

export { SummaryTotalSkeleton };
